export default __webpack_public_path__ + "static/media/gallery-wip-emitter_03.43a2386b.jpg";